import { render } from "./contact-support.vue?vue&type=template&id=9aa54464&scoped=true&ts=true"
import script from "./contact-support.vue?vue&type=script&lang=ts"
export * from "./contact-support.vue?vue&type=script&lang=ts"

import "./contact-support.vue?vue&type=style&index=0&id=9aa54464&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa54464"]])

export default __exports__